module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e100310"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Chapter 1 ")]), _c('br'), _c('br'), _c('i', [_vm._v("Understanding the Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "h1c",
    attrs: {
      "id": "d7e101110"
    }
  }, [_vm._v("10 Things You Will Learn in this Chapter ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e101610"
    }
  }, [_vm._v("• About Hans Asperger—the Austrian pediatrician who formally defined the syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e102710"
    }
  }, [_vm._v("• What the “Refrigerator Mother Theory” is.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e103210"
    }
  }, [_vm._v("• How genetics might play a role in Asperger’s.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e104010"
    }
  }, [_vm._v("• What the current definition is.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e104510"
    }
  }, [_vm._v("• How the diagnosis has changed in the past years.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e105110"
    }
  }, [_vm._v("• Why there is a skyrocketing increase in the number of children identified with autism and Asperger’s Syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e106510"
    }
  }, [_vm._v("• How to recognize a missed diagnosis.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e107110"
    }
  }, [_vm._v("• Recent statistics about the prevalence of the syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e107910"
    }
  }, [_vm._v("• How Asperger’s can be misdiagnosed as another mental health experience.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e109110"
    }
  }, [_vm._v("• How you or your child’s other parent may have Asperger’s too.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e113811"
    }
  }, [_c('b', [_vm._v("A Bit of History ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e114311"
    }
  }, [_vm._v("Asperger’s Syndrome was first formally defined in 1944 by Hans Asperger, an Austrian pediatrician. Asperger studied social interactions, communication, and behavior in children with different ways of being. In 1943, he studied a group of children, mostly boys, who had difficulty interacting in socially acceptable ways. The children appeared intrinsic or self-centered—not necessarily selfish, but rather, they preferred to keep to themselves. Another common characteristic was that they were not physically adept, and were rather uncoordinated. Most experienced no cognitive delays and were, in fact, quite articulate, with a strong command of vocabulary. The children engaged in repetitive physical actions, or were fascinated with nuances of timetables or the mechanics of certain objects such as clocks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e121011"
    }
  }, [_c('b', [_c('i', [_vm._v("Asperger’s in the Past ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e121711"
    }
  }, [_vm._v("Asperger published his findings in a paper titled “Autistic Psychopathy.” By today’s standards, the title is alarming and disrespectful but, in using the word “psychopathy,” Asperger did not intend to describe mentally ill, violent behavior; he was using the clinically acceptable jargon of the day. Asperger’s findings were the first documented collection of traits now used to diagnose Asperger’s Syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e126211"
    }
  }, [_vm._v("Unknown to Asperger, a psychiatrist named Leo Kanner was conducting similar research at Johns Hopkins University at about the same time. In 1943, Kanner chose the word “autism” (from the Greek word "), _c('i', [_vm._v("autos, ")]), _vm._v("or “self ”) to describe a group of children who shared like, but stereotyped, personality traits, engaged in solitary actions, and who struggled with expressing communication that was effective, reliable, and understandable. In postwar Austria, Asperger’s paper languished while Kanner’s research received recognition.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e132412"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e133112"
    }
  }, [_vm._v("Hans Asperger’s findings were published nearly simultaneously with the research of Leo Kanner, another doctor who, in 1944, first distinguished the traits of autism. The two physicians were unknown to one another. Because Asperger’s paper was published in German, and Kanner’s in English, Kanner’s research received broader distribution and was subsequently popularized. Hans Asperger passed away in 1980 before his research was universally applied.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e138612"
    }
  }, [_c('b', [_vm._v("Autism Spectrum Explained ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e139112"
    }
  }, [_vm._v("Despite the growing recognition of autism as an acceptable diagnosis during the 1950s and 1960s, Hans Asperger’s research went largely unnoticed. Still, there were individuals who experienced autistic-like symptoms but did not have the cognitive differences usually found in those with autism. At the time, such individuals were diagnosed with mental illness or nervous anxiety. Some were institutionalized or imprisoned because of their odd behavior or because they were gullible and easily manipulated into making poor or dangerous choices.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e144913"
    }
  }, [_c('b', [_c('i', [_vm._v("The “Refrigerator Mother Theory”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e145613"
    }
  }, [_vm._v("A popular theory to explain the alleged distance felt between parents, mothers in particular, and their children with autism was similarly applied to those with autistic-like symptoms. It was called “Refrigerator Mother Theory,” which referred to the supposed aloofness or indifference shown by mothers unable to connect with their children. This theory reinforced the notion that mothers deliberately induced Asperger’s in their children—when in fact, Asperger’s Syndrome is no one’s fault.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e149913"
    }
  }, [_c('b', [_c('i', [_vm._v("How Do Genetics Play a Role?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e150413"
    }
  }, [_vm._v("Some recent theories being researched to explain the prevalence of autism and Asperger’s Syndrome include genetics, environmental factors (pregnant mothers’ exposure to or ingestion of chemical elements), or children’s reactions to the mercury preservative in certain childhood vaccinations. There is currently no prenatal or other biological exam to test for Asperger’s Syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e154113"
    }
  }, [_vm._v("It wasn’t until 1981 that British psychiatrist Lorna Wing revived Hans Asperger’s findings in a research paper of her own. This eventually led to the reclassification of autistic experiences in the clinical document titled "), _c('i', [_vm._v("Diagnostic and Statistical Manual of Mental Disorders ")]), _vm._v("(or, as it is more commonly referred to, "), _c('i', [_vm._v("DSM")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e157813"
    }
  }, [_c('b', [_vm._v("Current Definition ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e158413"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("DSM ")]), _vm._v("is published in the United States by the American Psychiatric Association. As of this writing, its fourth edition, published in 1994, is still in effect. This was the first edition of the "), _c('i', [_vm._v("DSM ")]), _vm._v("to formally recognize Asperger’s Syndrome, which was categorized under the general heading Pervasive Developmental Disorders (PDD). In addition to Asperger’s, there are several other diagnoses that fall under the PDD heading. These include:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e164214"
    }
  }, [_vm._v("• Autistic disorder (known as autism)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e166114"
    }
  }, [_vm._v("• Rett disorder (or Rett Syndrome) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e167114"
    }
  }, [_vm._v("• Childhood disintegrative disorder ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e167614"
    }
  }, [_vm._v("• Asperger’s disorder (known as Asperger’s Syndrome) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e169314"
    }
  }, [_vm._v("• Pervasive developmental disorder not otherwise specified (or PDD-NOS) "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e171214"
    }
  }, [_vm._v("These are all subcategories of the PDD diagnosis. At present, these experiences are collectively grouped under the PDD heading because of the similarities of symptoms related to challenges in communication, social interaction, and so-called stereotyped behaviors, interests, and activities. Autism is the most prevalent of these experiences, more common than Down Syndrome or childhood cancer. Rett disorder is usually found in little girls before the age of four. Childhood disintegrative disorder impacts children before the age of ten. In both circumstances, and for unknown reasons, children experience a loss of previously acquired social skills, language, motor skills, play, and self-care. The category pervasive developmental disorder not otherwise specified (PDD-NOS) is used when a child demonstrates autistic-like symptoms but misses meeting the criteria for the other diagnoses.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e179515"
    }
  }, [_c('b', [_c('i', [_vm._v("Have You Heard the Term Highly Functional?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e180215"
    }
  }, [_vm._v("Some clinicians consider the terms "), _c('i', [_vm._v("high-functioning ")]), _c('i', [_vm._v("autism ")]), _vm._v("or "), _c('i', [_vm._v("mild autism ")]), _vm._v("synonymous with Asperger’s Syndrome. The "), _c('i', [_vm._v("DSM ")]), _vm._v("does not presently define this term, so it may or may not apply to a child with Asperger’s. It may also be used to describe the child who demonstrates many skills yet still falls within the PDD-NOS range of diagnosis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e186315"
    }
  }, [_vm._v("PDD-NOS may be used by a physician unaccustomed to diagnosing Asperger’s, or it may be used if a doctor wishes to be cautious, to “wait and see” as a child grows and develops. Sometimes, when the PDD-NOS diagnosis is revisited, a child has matured into an official Asperger’s diagnosis. However, the "), _c('i', [_vm._v("DSM ")]), _vm._v("is a dynamic document, and as the psychiatric field grows and becomes more knowledgeable, reorganization of Asperger’s and autistic experiences is inevitable in future, revised editions.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e192115"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e193315"
    }
  }, [_vm._v("Asperger’s Syndrome is a neurological condition that primarily creates challenges in understanding social interactions. Asperger’s is not a disease or chronic mental illness. It is a natural, lifelong experience.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e196115"
    }
  }, [_c('b', [_c('i', [_vm._v("Clinical Criteria ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e196615"
    }
  }, [_vm._v("As we’ve learned, Asperger’s Syndrome is presently grouped under the diagnostic “umbrella” heading pervasive developmental disorders, along with other disorders with similar symptoms. As currently defined by the "), _c('i', [_vm._v("DSM")]), _vm._v(", a child with Asperger’s differs from the child with autism because of the following traits:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e201016"
    }
  }, [_vm._v("• No clinically significant delays in language ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t00616"
    }
  }, [_vm._v("• No clinically significant delays in cognitive development ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e203516"
    }
  }, [_vm._v("• No clinically significant delays in development of age-appropriate self-help skills ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e204616"
    }
  }, [_vm._v("• No clinically significant delays in adaptive behavior (other than social interaction) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t00516"
    }
  }, [_vm._v("• No clinically significant delays in curiosity about the environment in childhood ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e207516"
    }
  }, [_c('b', [_c('i', [_vm._v("Does Your Child Qualify?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e208216"
    }
  }, [_vm._v("To qualify for an Asperger’s Syndrome diagnosis, a child must demonstrate impairment in social interaction, shown by at least two of the following:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e210016"
    }
  }, [_vm._v("• Impairment in the use of nonverbal behaviors (such as eye contact, facial expressions, and gestures) during social interaction ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e211616"
    }
  }, [_vm._v("• Lack of development of relationships with peers ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e212116"
    }
  }, [_vm._v("• Failure to seek to share enjoyment, interests, or achievements with other people (for instance, by not showing objects of interest to others) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e214316"
    }
  }, [_vm._v("• Failure to reciprocate emotions or social gestures "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214816"
    }
  }, [_vm._v("The child should also demonstrate “restrictive repetitive and stereotyped patterns of behaviors, interests, and activities,” shown by at least one of the following:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e216617"
    }
  }, [_vm._v("• Unusually intense preoccupation with one or more stereotyped interests ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e217717"
    }
  }, [_vm._v("• Obsessively following specific, nonfunctional routines or rituals ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t00717"
    }
  }, [_vm._v(" • Repeated motions, such as hand or finger flapping or twisting ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e220917"
    }
  }, [_vm._v("• Unusual preoccupation with parts of objects "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e221717"
    }
  }, [_vm._v("To qualify as characteristics of Asperger’s, these traits must be significant enough to cause great challenges for the child in social, occupational, and other important areas of daily living. Although, increasingly, some children with Asperger’s have been diagnosed as young as three, the diagnosis is most often made from age six and up.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e225217"
    }
  }, [_c('b', [_c('i', [_vm._v("It’s Your Personal Experience ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e225717"
    }
  }, [_vm._v("The word “disorder” may not seem like a family friendly way to describe your child’s personal Asperger’s Syndrome experience, but it is currently clinical “shorthand” to summarize it. Please do not be hurt, confused, or upset by this technical jargon. Outside of a doctor’s office, you may wish to use the word “difference” or the phrase “different way of being” when you feel the need to describe your child’s experience, if at all. Your child’s physician, educators, or school psychologist may be able to recommend literature in addition to the "), _c('i', [_vm._v("DSM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e230918"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e231618"
    }
  }, [_vm._v("The Diagnostic and Statistical Manual catalogs a wide range of mental health and related experiences. It is the foremost reference guide used by psychiatrists, psychologists, social workers, mental health professionals, therapists, counselors, and nurses, to name a few. It provides a framework to diagnose someone’s experience according to symptoms. The first edition was originally published in 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e235318"
    }
  }, [_c('b', [_vm._v("Sensory Sensitivity: Asperger’s and Autism ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e236618"
    }
  }, [_vm._v("Having just reviewed the clinical criteria for the diagnosis of Asperger’s Syndrome, you may be filled with many questions and concerns. Some of what was described may match what you know to be true of your child. But you might be surprised to see that other areas weren’t included. What about the child who screams and covers his ears when an ambulance goes by, blaring its siren? Or the child who cannot tolerate the taste of Jell-O or pudding in her mouth? These are called sensory sensitivities, a commonality shared with persons with autism but not defined by the DSM as clinical criteria. It is important to note that some children without Asperger’s Syndrome or any medical problems at all can have some of these sensitivities too though.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e242618"
    }
  }, [_c('b', [_c('i', [_vm._v("Frequency of Symptoms ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t00818"
    }
  }, [_vm._v("Your child may vibrate at a different “frequency” than most others. That is, he may be described as “exquisitely sensitive.” Because of this, his entire nervous system— his senses and emotions—may be routinely impacted by stimulation others filter out naturally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e245919"
    }
  }, [_vm._v("Many children with Asperger’s share some common sensitivities with people with autism. The most common sensory sensitivities are:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e247719"
    }
  }, [_vm._v("• Auditory (including intolerable noise or frequency levels) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e248819"
    }
  }, [_vm._v("• Smell and taste ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e249619"
    }
  }, [_vm._v("• Visual")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e251819"
    }
  }, [_vm._v("• Touch ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e252319"
    }
  }, [_c('b', [_c('i', [_vm._v("Auditory Sensitivity ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e252819"
    }
  }, [_vm._v("The child with exquisitely sensitive hearing may cry and recoil from a variety of sounds. She reacts in this way because in a very real sense, she is physically hurting from the intensity of the noise. The most offensive sounds are those that are not only very loud and startling but also "), _c('i', [_vm._v("unpredictable")]), _vm._v(", meaning there’s no telling when or where they will occur with any certainty. The most commonly hurtful, unpredictable sounds for someone with especially sensitive hearing include (in no particular order): dogs barking; babies crying; crowd noises; vacuum cleaners; police, ambulance, and fire engine sirens, or cars backfiring; loud music or television programs not of the child’s choosing; public announcement systems and intercoms; people tapping, clicking, or snapping fingers or objects (such as a pencil); and people laughing, talking, or sneezing loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e259820"
    }
  }, [_c('b', [_c('i', [_vm._v("Taste and Smell ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e260320"
    }
  }, [_vm._v("Certain smells (especially food scents and perfumes or toiletries) and tastes may also be overwhelming. On occasion, a child may gag and vomit in reaction to the sensation of the smell or texture of foods. Unable to explain herself in the moment, the child may bolt from the environment if the smells or tastes become too much for her to handle.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e262920"
    }
  }, [_c('b', [_c('i', [_vm._v("Visual Sensitivity ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e263420"
    }
  }, [_vm._v("Because many people with Asperger’s are very visual in how they absorb and process information, they may also become readily overwhelmed by too many visual details in a single environment (think Wal*Mart on a Saturday afternoon). The number of moving, flapping, or spinning objects paired with the vivid mix of colors and combined with too many people cramped together in a single location can push the child with Asperger’s into sensory overload. The same is true for many of us!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e268320"
    }
  }, [_vm._v("Light that is too intense can also cause pain and discomfort. Overhead fluorescent lighting is a harsh, abrasive, and unnatural illumination that is especially troublesome for many people with both Asperger’s and autism. In addition to its intensity, fluorescent lighting may flicker and buzz. The flickering and buzzing may go completely unnoticed by others but will become unbearable for the child with heightened sensitivities.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e272121"
    }
  }, [_c('b', [_c('i', [_vm._v("Touch ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t00921"
    }
  }, [_vm._v("Finally, the sensation of touch may be equally overwhelming for the child with Asperger’s. Being hugged, patted on the head or back, or picked up—especially unpredictably and without warning or permission—may cause the child to cry, bite, or even hit. The challenge is that children, particularly small children, often tend to be hugged, patted, and picked up simply because they’re adorable. The people doing the touching are well intentioned but don’t yet understand that the concept of respecting someone’s personal space also applies to children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277421"
    }
  }, [_vm._v("The texture of certain clothing fabrics worn against one’s skin may create extreme discomfort and physical irritation as well. This unpleasant sensation has been likened to one’s flesh being rubbed raw with sandpaper. For some, cotton and natural fiber clothes are a must to ward against the manifestation of skin welts and rashes. Conversely, other children with Asperger’s may welcome (and initiate seeking out) the sensory input provided by the deep-pressured touch offered by bear hugs and massage, or burrowing under sofa cushions and mattresses, or self-swaddling in comforters and sleeping bags. The difference here is that these activities occur on the child’s terms and at her specifications of endurance.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e282821"
    }
  }, [_c('b', [_c('i', [_vm._v("Other Commonalities ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e283321"
    }
  }, [_vm._v("Another commonality children with Asperger’s Syndrome may have with those with autism is “flat affect” expressions and somewhat different speech patterns. A flat affect refers to facial expressions that are fixed or “artificial” in appearance instead of naturally animated. The child may not laugh or smile unless cued to do so in an appropriate situation, or the child may appear to have a collection of rehearsed or “canned” reactions to match certain circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e288022"
    }
  }, [_c('i', [_vm._v("The Way Your Child Speaks ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e288522"
    }
  }, [_vm._v("The child’s way of talking may also seem “flat” and monotone. The child’s words may sound robotic and carefully measured. Or there may be a lilting tone to her voice, described by some as “singsong,” in which her speech sounds like it’s bouncing up and down when she talks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e290822"
    }
  }, [_c('i', [_vm._v("Where’s His Commonsense?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291522"
    }
  }, [_vm._v("Often, the child with Asperger’s may find it challenging to demonstrate or understand what others take for granted as a commonsense manner of thought. The child may have a logic all his own that perplexes or exasperates others because it is not representative of the norm. He may not grasp certain social rules or ways of doing things, explained away by others with the phrase “just because.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e295022"
    }
  }, [_c('b', [_c('i', [_vm._v("Keeping Order ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e295522"
    }
  }, [_vm._v("It is also not uncommon for many children with Asperger’s Syndrome to have a desire to maintain order, peace, and tranquility. Your child may (from his logic and perspective) initiate great and creative measures to make others happy and content to maintain the status quo, even if it means making decisions that adults may judge as unwise or unacceptable. It may have more to do with desiring to please in order to keep the peace than with being intuitive to others’ needs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e299423"
    }
  }, [_vm._v("It is important to appreciate that none of these reactions are typically “attention-seeking” or deliberately “bad” or noncompliant behaviors. They are a genuine reaction to extreme, hurtful disturbances in the child’s immediate environment. For example, one mother assumed her son was engaging her in a power struggle when he refused to wear the new blue jeans he had picked out in the store and that she purchased for him. He complained that they scratched when he wore them. He was speaking truthfully, but mom wasn’t listening carefully enough to his words. Washing the new jeans several times to soften them made them physically tolerable, and the conflict was resolved without further incident. This concept of distinguishing an “Asperger’s moment” from typical kid behavior will make more sense as you continue reading. Helping the child with Asperger’s to cope with his sensory sensitivities will be explored in more detail later in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e306823"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Diagnostic and Statistical Manual ")]), _vm._v("does not presently include any of the previous autistic-like commonalities as clinical criteria for autism or Asperger’s Syndrome. These attributes, while valid in many children, have become stereotypes when some doctors, journalists, and others generically describe those with Asperger’s Syndrome. Asperger’s is as unique and individual an experience as each individual is unique. You may find that some, all, or none of these nonclinical, autistic-like commonalities make sense when you think about your child’s way of being in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e313524"
    }
  }, [_vm._v("DOES THIS SOUND LIKE YOUR CHILD?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e314224"
    }
  }, [_vm._v("Your child may have Asperger’s Syndrome if he or she finds it difficult to make friends; doesn’t seem to understand nonverbal communications, like body language or facial expressions; doesn’t understand or appears insensitive to others’ feelings; is deeply passionate about one or more subject areas; is not physically graceful; has great difficulty accepting change in routine or schedule; or has a different or mechanical-sounding speech patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e317724"
    }
  }, [_c('b', [_vm._v("Diagnosing Today ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e318524"
    }
  }, [_vm._v("There has been a great deal of attention given by the media to the staggering, skyrocketing increase in the numbers of children identified with autism. It has been legitimately described as an epidemic explosion. Fifteen years ago, it was estimated that 1 in 10,000 individuals was autistic. In the 1990s, the estimate narrowed to 1 in 1,000, then 1 in every 500, then 1 in every 250 children. Today, the statistics fluctuate regularly, growing closer and closer all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e322324"
    }
  }, [_vm._v("Recent tallies, such as that proffered by "), _c('i', [_vm._v("Time ")]), _vm._v("magazine in 2002, suggest that 1 in every 150 children under the age of ten has autism.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e324525"
    }
  }, [_c('b', [_c('i', [_vm._v("Why the Increase in Cases?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e325225"
    }
  }, [_vm._v("According to a 2002 study commissioned by the California Legislature, during the past fifteen years in the state of California alone, the number of children identified with autism has leapt by 643 percent. Another recent statistic estimated that 1 in every 5 children has either autism, dyslexia, attention deficit hyperactivity disorder, or some form of uncontrollable aggression. In 2003, the federal Centers for Disease Control and Prevention estimated that of the children born daily in the United States, 53 will be diagnosed with autism, or roughly 19,000 infants per year. As noted earlier, this rise is occurring without any single known cause or indicator.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e329825"
    }
  }, [_c('b', [_c('i', [_vm._v("How to Understand the New Findings ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t01025"
    }
  }, [_vm._v("Where does this leave our understanding of the prevalence of Asperger’s Syndrome? With so much attention being given to young children newly diagnosed with autism, those with Asperger’s Syndrome are not usually identified and tracked in the same manner by doctors or our education system. We may speculate that there are a number of reasons for this:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e334225"
    }
  }, [_vm._v("• Families who live in isolated or rural areas, or have limited contact with others with similar-aged, typically developing children, may not recognize their child’s differences or may be distanced from proper support systems to obtain a diagnosis.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e337326"
    }
  }, [_vm._v("• Family practitioners and other physicians may be unaccustomed to identifying the symptoms of autism, let alone understanding the criteria for Asperger’s Syndrome. They may have little to no experience with Asperger’s or limited resources from which to gather more information.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e340526"
    }
  }, [_vm._v("• The child of school age undiagnosed with Asperger’s may be labeled as noncompliant or lazy. Parents and teachers may believe she is simply not applying herself to her full potential.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e342426"
    }
  }, [_vm._v("• The child may be seen as simply quirky or especially gifted, leading to the “Little Professor” moniker that has become a popular way of describing children with Asperger’s who present as technically proficient miniature adults.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e344726"
    }
  }, [_vm._v("• The child may have a diagnosis of hyperlexia, an experience that may outwardly present itself as similar to Asperger’s in that the child may be highly fluent. Hyperlexia is marked by a precocious capacity for reading that far exceeds the child’s chronological age; however, the child may be unable to comprehend all that has been read. The child may be fascinated with numbers, may need to keep specific routines, and may be challenged in social interactions.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e349626"
    }
  }, [_vm._v("• The child has a “ballpark” diagnosis but, as noted earlier, it is labeled as PDD-NOS or high-functioning autism. As such, it is not specifically identified as Asperger’s.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e354127"
    }
  }, [_c('b', [_c('i', [_vm._v("What about a Missed Diagnosis?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e354827"
    }
  }, [_vm._v("Because the clinical criteria for Asperger’s calls for no significant cognitive or developmental delays, it is often undetected until a child is past the age of eligibility for early intervention services. It is also possible for Asperger’s Syndrome to go undiagnosed altogether, because it can be so subtle. It could also be misdiagnosed as another issue such as a learning disorder, attention deficit disorder, attention deficit hyperactivity disorder, dyslexia, schizophrenia, generalized anxiety disorder, Tourette’s syndrome, obsessive-compulsive disorder, oppositional defiant disorder, bipolar disorder, intermittent explosive disorder, or depression—all mental health experiences listed in the "), _c('i', [_vm._v("DSM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e360827"
    }
  }, [_c('b', [_c('i', [_vm._v("What Is the Truth?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e361527"
    }
  }, [_vm._v("Given all this, what "), _c('i', [_vm._v("do ")]), _vm._v("we know about the prevalence of Asperger’s Syndrome? Like autism, Asperger’s knows no social, cultural, or economic boundaries. And, also like autism, it is four times more likely to be found in males than females (again, for reasons presently unknown). Until recently, Asperger’s, like the prevalence of autism, was believed to be largely a male experience, but as our culture is becoming more aware and better educated to such social issues, more females with Asperger’s are being identified. Conservative estimates conclude that 1 in every 1,000 children has Asperger’s Syndrome. However, as we’ve seen with autism, the increasing recognition of Asperger’s will surely prompt that statistic to increase in the near future.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8311c14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stil_9781598696677_epub_c7_r1.vue
// module id = 75
// module chunks = 0